import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { AccountMenu, AccountMenuSpacing, Button, ButtonSize, ButtonVariant, IconName, IconColor, IconSize, Popover, PopoverSize, usePopoverHandlers, } from '@as/cotopaxi';
import { useAemConfig } from '@as-react/common-components';
import { Box, Breakpoint, TextAlpha } from '@yonderland/andes-react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
import { useFeatureToggle } from '../../hooks/useFeatureToggle';
import { useOAuth } from '../../hooks/useOAuth';
import sessionActions from '../../redux/session/actions/SessionActions.creators';
import { makeGetLoggedInState, makeGetSessionState } from '../../redux/session/selectors/SessionSelector';
const AccountMenuProfileContainer = ({ items, hideOnMobile, title }) => {
    var _a;
    const { t } = useTranslation(I18N_NAMESPACES.account);
    const accountMenuTranslations = {
        logout: t(`${I18N_NAMESPACES.account}:account.logout`),
    };
    const { anchorEl, handlePopoverOpen, handlePopoverClose } = usePopoverHandlers();
    const isLoggedIn = useSelector(makeGetLoggedInState());
    const sessionState = useSelector(makeGetSessionState());
    const dispatch = useDispatch();
    const { logout } = useOAuth();
    const isNewAuthFlowEnabled = useFeatureToggle('use_new_auth_flow');
    const { isInAuthorMode } = useAemConfig();
    const handleLogout = () => (isNewAuthFlowEnabled ? logout() : dispatch(sessionActions.createLogoutAction()));
    const [shouldRender, setShouldRender] = useState(isInAuthorMode);
    const mappedItems = items
        .filter(item => !item.hideForGuest || isLoggedIn)
        .map(item => ({
        href: item.link,
        label: item.label,
        isActive: item.active,
    }));
    const activeItemLabel = (_a = mappedItems.find(item => item.isActive)) === null || _a === void 0 ? void 0 : _a.label;
    useEffect(() => {
        var _a;
        if (((_a = sessionState === null || sessionState === void 0 ? void 0 : sessionState.authorities) === null || _a === void 0 ? void 0 : _a.length) && !shouldRender) {
            setShouldRender(true);
        }
    }, [sessionState]);
    if (!shouldRender)
        return null;
    return (_jsxs(_Fragment, { children: [_jsxs(Breakpoint, { from: "lg", children: [title.show && (_jsx(Box, { paddingBlockEnd: "3", children: _jsx(TextAlpha, { as: "h3", variant: "subheadingS", children: title.value || t('account.account.popover') }) })), _jsx(AccountMenu, { spacing: AccountMenuSpacing.SMALL, buttonSize: ButtonSize.SMALL, items: mappedItems, onLogout: isLoggedIn ? handleLogout : undefined, noMarginRight: true, translations: accountMenuTranslations })] }), _jsxs(Breakpoint, { until: "lg", children: [!hideOnMobile && (_jsx(Box, { paddingBlockEnd: "6", marginInline: { base: '-4', md: '0' }, children: _jsx(Button, { size: ButtonSize.XSMALL, variant: ButtonVariant.LINK_SUBTLE, onClick: handlePopoverOpen, text: _jsx(TextAlpha, { as: "h2", variant: "headingS", children: activeItemLabel }), iconRight: { name: IconName.CHEVRON_RIGHT, size: IconSize.MINOR } }) })), _jsx(Popover, { anchorEl: anchorEl, onClose: handlePopoverClose, title: title.show ? title.value || t('account.account.popover') : null, rightElement: _jsx(Button, { variant: ButtonVariant.TRANSPARENT, onClick: handlePopoverClose, icon: {
                                name: IconName.CLOSE,
                                color: IconColor.ACTION,
                                size: IconSize.MAJOR,
                            } }), size: PopoverSize.MEDIUM, children: _jsx(AccountMenu, { items: mappedItems, onLogout: isLoggedIn ? handleLogout : undefined, translations: accountMenuTranslations }) })] })] }));
};
export default AccountMenuProfileContainer;
